//Uncomment this line on creating a translation file
import { editorLocalization, defaultStrings } from "survey-creator-core";

export var arStrings = {
  //survey templates
  survey: {
    edit: "تعديل",
    externalHelpLink: "شاهد وتعلم كيف يتم إنشاء إستبيان",
    externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    dropQuestion: "الرجاء إفلات السؤال هنا من صندوق الأدوات",
    addLogicItem: ".قم بإنشاء قاعدة لتخصيص تدفق الإستبيان",
    copy: "نسخ",
    duplicate: "نسخة طبق الأصل",
    settings: "الإعدادات",
    addToToolbox: "إضافة إلى صندوق الأدوات",
    deletePanel: "حذف لوحة",
    deleteQuestion: "حذف سؤال",
    convertTo: "تحويل إلى",
    drag: "إسحب العنصر",
    license: "الرجاء شراء ترخيص مطور SurveyJS Creator لاستخدامه في تطبيقك",
  },
  //questionTypes
  qt: {
    default: "الإفتراضي",
    checkbox: "إختيار من متعدد",
    comment: "تعليق",
    imagepicker: "إنتقاء الصور",
    ranking: "تصنيف",
    image: "صورة",
    dropdown: "قائمة منسدلة",
    file: "ملف",
    html: "لغة ترميز النصوص HTML",
    matrix: "مصفوفة (إختيار واحد)",
    matrixdropdown: "مصفوفة (إختيار متعدد)",
    matrixdynamic: "مصفوفة (صفوف ديناميكية)",
    multipletext: "مدخل متعدد",
    panel: "لوحة",
    paneldynamic: "لوحة ديناميكية",
    radiogroup: "إختيار فردي",
    rating: "تقييم",
    text: "مٌدخل فردي",
    boolean: "قيمة منطقية",
    expression: "عملية حسابية (للقرائة فقط)",
    signaturepad: "لوحة توقيع",
    buttongroup: "Button group",
    flowpanel: "Flow Panel",
  },
  //Strings in SurveyJS Creator
  ed: {
    defaultLocale: "إفتراضي ({0})",
    survey: "Survey1",
    settings: "Survey Settings",
    settingsTooltip: "Open survey settings",
    //opjectPropertiesHeader: "Advanced",
    //showObjectProperties: "Show Object Properties",
    //hideObjectProperties: "Hide Object Properties",
    showPanel: "إظهار اللوحة",
    hidePanel: "إخفاء اللوحة",
    prevSelected: "Select previous",
    nextSelected: "Select next",
    //editSurvey: "Edit Survey",
    surveyTypeName: "الإستبيان",
    pageTypeName: "الصفحة",
    panelTypeName: "اللوحة",
    questionTypeName: "السؤال",
    columnTypeName: "Column",
    addNewPage: "Add New Page",
    moveRight: "Scroll to the Right",
    moveLeft: "Scroll to the Left",
    deletePage: "Delete Page",
    editPage: "Edit Page",
    edit: "التعديل",
    newPageName: "الصفحة",
    newQuestionName: "السؤال",
    newPanelName: "اللوحة",
    newTextItemName: "text",
    testSurvey: "تجربة الإستبيان",
    testSurveyAgain: "Test Survey Again",
    testSurveyWidth: "Survey width: ",
    navigateToMsg: "You had to navigate to:",
    logic: "منطق الإستبيان",
    embedSurvey: "Embed Survey",
    translation: "Translation",
    saveSurvey: "Save Survey",
    saveSurveyTooltip: "Save Survey",
    designer: "تصميم الإستبيان",
    jsonEditor: "JSON Editor",
    jsonHideErrors: "Hide errors",
    jsonShowErrors: "Show errors",
    undo: "Undo",
    redo: "Redo",
    undoTooltip: "Undo last change",
    redoTooltip: "Redo the change",
    copy: "Copy",
    cut: "Cut",
    paste: "Paste",
    copyTooltip: "Copy selection to clipboard",
    cutTooltip: "Cut selection to clipboard",
    pasteTooltip: "Paste from clipboard",
    options: "Options",
    generateValidJSON: "Generate Valid JSON",
    generateReadableJSON: "Generate Readable JSON",
    toolbox: "Toolbox",
    "property-grid": "Properties",
    propertyGridFilteredTextPlaceholder: "Type to search...",
    toolboxGeneralCategory: "قائمة العام",
    //delSelObject: "Delete selected object",
    //editSelObject: "Edit selected object",
    correctJSON: "Please correct JSON.",
    surveyResults: "Survey Results ",
    surveyResultsTable: "As Table",
    surveyResultsJson: "As JSON",
    resultsTitle: "Question Title",
    resultsName: "Question Name",
    resultsValue: "Answer Value",
    resultsDisplayValue: "Display Value",
    modified: "هناك تعديل جديد",
    saving: "يتم الآن حفظ التغييرات",
    saved: "تم الحفظ",
    propertyEditorError: "خطأ:",
    saveError: "Error! Editor content is not saved.",
    translationPropertyGridTitle: "Language Settings",
    translationLanguages: "Languages",
    translationAddLanguage: "Select language to translate",
    translationShowAllStrings: "Show all strings",
    translationShowAllPages: "Show all pages",
    translationNoStrings: "No strings to translate. Please, change the filter.",
    translationExportToSCVButton: "Export to CSV",
    translationImportFromSCVButton: "Import from CSV",
    translationMergeLocaleWithDefault: "Merge {0} with default locale",
    translationPlaceHolder: "Translation...",
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    addNewQuestion: "Add Question",
    selectPage: "Select page...",
    htmlPlaceHolder: "محتوى HTML سيكون هنا",
    signHere: "التوقيع هنا",
    panelPlaceHolder: "قم بإسقاط السؤال من صندوق الأدوات إلى هنا",
    addNewTypeQuestion: "Add {0}",
    chooseLogoPlaceholder: "[الشعار]",
    //completedHtmlOnConditionItemText: "Show if:",
    lg: {
      addNewItem: "",
      //Logic tab strings
      empty_tab: "قم بإنشاء إرتباط لتخصيص تدفق الإستبيان",
      page_visibilityName: "إظهار (إخفاء) صفحة",
      panel_visibilityName: "إظهار (إخفاء) لوحة",
      panel_enableName: "تفعيل (تعطيل) لوحة",
      question_visibilityName: "إظهار (إخفاء) سؤال",
      question_enableName: "تفعيل (تعطيل) سؤال",
      question_requireName: "جعل السؤال إلزامي",
      trigger_completeName: "أنهي الإستبيان",
      trigger_setvalueName: "تحديد قيمة السؤال",
      trigger_copyvalueName: "نسخ قيمة السؤال",
      trigger_skipName: "التخطي إلى السؤال",
      trigger_runExpressionName: "تشغيل تعبير رياضي مخصص",
      completedHtmlOnConditionName: "نص رسالة شكر مخصصة",
      page_visibilityDescription: "Make the page visible when the logic expression returns true. Otherwise keep it invisible.",
      panel_visibilityDescription: "Make the panel visible when the logic expression returns true. Otherwise keep it invisible.",
      panel_enableDescription: "Make the panel, and all elements inside it, enable when the logic expression returns true. Otherwise keep them disabled.",
      question_visibilityDescription: "Make the question visible when the logic expression returns true. Otherwise keep it invisible.",
      question_enableDescription: "Make the question enable when the logic expression returns true. Otherwise keep it disabled.",
      question_requireDescription: "Question becomes required when the logic expression returns true.",
      trigger_completeDescription: "When the logic expression returns true then the survey becomes completed and an end-user see the 'Thank you page'.",
      trigger_setvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value is set to the selected question.",
      trigger_copyvalueDescription: "When question values, that are used in the logic expression, are changed and the logic expression returns true, then the value of one selected question is copied to another selected question.",
      trigger_skipDescription: "When the logic expression returns true then the survey skip to / focus the selected question.",
      trigger_runExpressionDescription: "When the logic expression returns true, then the custom expression is performed. You may optionally set this expression result into the selected question",
      completedHtmlOnConditionDescription: "If the logic expression returns true, then the default text for the 'Thank you page' is changed to the given one.",
      itemExpressionText: "عندما التعبير '{0}' رجع قيمة المنطقية صحيح",
      itemEmptyExpressionText: "الإرتباط الجديد لم يحدد",
      page_visibilityText: "جعل الصفحة {0} مرئية",
      panel_visibilityText: "جعل اللوحة {0} مرئية",
      panel_enableText: "جعل اللوحة {0} مفعلة",
      question_visibilityText: "جعل السؤال {0} مرئي",
      question_enableText: "جعل السؤال {0} مفعل",
      question_requireText: "جعل السؤال {0} إلزامي",
      trigger_completeText: "الإستبيان سيصبح مكتمل",
      trigger_setvalueText: "تثبيت إلى السؤال: {0} القيمة {1}",
      trigger_copyvalueText: "النسخ إلى السؤال: {0} القيمة القادمة من السؤال {1}",
      trigger_skipText: "التخطي إلى السؤال {0}",
      trigger_runExpressionText1: "شغل التعبير الرياضي '{0}'",
      trigger_runExpressionText2: " وثبت نتيجتها إلى السؤال {0}",
      completedHtmlOnConditionText: "عرض نص رسال 'صفحة شكر' مخصصة",
      showAllQuestions: "عرض كل الأسئلة",
      showAllActionTypes: "عرض كل أنواع الإجراءات",
      conditions: "Condition(s)",
      actions: "Action(s)",
      expressionEditorTitle: "تعريف شرط(إشتراطات)",
      actionsEditorTitle: "تعريف إجراء (إجراءات)",
      deleteAction: "حذف الإجراء",
      addNewAction: "إضافة إجراء جديد",
      selectedActionCaption: "حدد الإجراء لأضافته",
      expressionInvalid: "التعبير المنطقي الرياضي فارغ أو غير صحيح، يرجى تصحيحه",
      noActionError: "الرجاء، إضافة إجراء واحد على الأقل",
      actionInvalid: "الرجاء، إصلاح الأخطاء في الإجراء التابع لك",
      expressionSetup: "",
      actionsSetup: "",
    },
  },
  //Property names in table headers
  // pel: {
  //   isRequired: "Required?"
  // },
  //Property Editors
  pe: {
    apply: "تطبيق",
    ok: "موافق",
    save: "حفظ",
    clear: "مسح",
    saveTooltip: "حفظ",
    cancel: "إلغاء",
    set: "تثبيت",
    reset: "Reset",
    change: "تغيير",
    refresh: "Refresh",
    close: "إغلاق",
    delete: "حذف",
    add: "إضافة",
    addNew: "إضافة إرتباط جديد",
    addItem: "Click to add an item...",
    removeItem: "Click to remove the item...",
    dragItem: "Drag the item",
    addOther: "Other",
    addSelectAll: "Select All",
    addNone: "None",
    removeAll: "Remove All",
    edit: "التعديل",
    back: "Return without saving",
    backTooltip: "Return without saving",
    saveAndBack: "Save and return",
    saveAndBackTooltip: "Save and return",
    doneEditing: "إضافة",
    // itemValueEdit: "Visible If",
    editChoices: "Edit Choices",
    showChoices: "Show Choices",
    move: "Move",
    empty: "<empty>",
    emptyValue: "القيمة فارغة",
    fastEntry: "إدخالات سريعة",
    fastEntryNonUniqueError: "Value '{0}' is not unique",
    fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}",
    formEntry: "Form Entry",
    testService: "Test the service",
    itemSelectorEmpty: "Please select the element",
    conditionActionEmpty: "Please select the action",
    conditionSelectQuestion: "إختر السؤال...",
    conditionSelectPage: "Select page...",
    conditionSelectPanel: "Select panel...",
    conditionValueQuestionTitle: "Please enter/select the value",
    // conditionHelp:
    //   "Please enter a boolean expression. It should return true to keep the question/page visible. For example: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
    expressionHelp: "You can use curly brackets to get access to the question values: {question1} + {question2}, ({price}*{quantity}) * (100 - {discount}). You can use functions as: iif(), today(), age(), min(), max(), count(), avg() and others.",
    aceEditorHelp: "Press ctrl+space to get expression completion hint",
    aceEditorRowTitle: "Current row",
    aceEditorPanelTitle: "Current panel",
    showMore: "For more details please check the documentation",
    // conditionShowMoreUrl:
    //   "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf",
    assistantTitle: "Available questions:",
    cellsEmptyRowsColumns: "There is should be at least one column or row",
    propertyIsEmpty: "Please enter a value",
    propertyIsNoUnique: "Please enter a unique value",
    propertyNameIsNotUnique: "Please enter a unique name",
    listIsEmpty: "No items have been added yet",
    expressionIsEmpty: "Expression is empty",
    value: "القيمة",
    text: "النص",
    rowid: "Row ID",
    imageLink: "رابط الصورة",
    columnEdit: "Edit column: {0}",
    itemEdit: "Edit item: {0}",
    url: "رابط إلكتروني URL",
    path: "المسار",
    valueName: "اسم القيمة",
    titleName: "اسم العنوان",
    imageLinkName: "اسم رابط الصورة",
    allowEmptyResponse: "السماح بجواب فارغ",
    titlePlaceholder: "Input title here",
    surveyTitlePlaceholder: "أدخل عنوان الإستبيان هنا",
    pageTitlePlaceholder: "أدخل عنوان الصفحة هنا",
    descriptionPlaceholder: "Enter a description",
    surveyDescriptionPlaceholder: "أدخل وصف للإستبيان",
    pageDescriptionPlaceholder: "أدخل وصف للصفحة",
    showOtherItem: "هل هناك خيار أخرى",
    otherText: "نص خيار أخرى",
    showNoneItem: "هل هناك خيار بلا",
    noneText: "نص خيار بلا",
    showSelectAllItem: "هل هناك خيار إختيار الكل",
    selectAllText: "نص خيار إختر الكل",
    choicesMin: "Minimum value for auto generated items",
    choicesMax: "Maximum value for auto generated items",
    choicesStep: "The difference between auto generated items",
    name: "الإسم",
    title: "العنوان",
    cellType: "نوع الخلية",
    colCount: "عدد الأعمدة",
    choicesOrder: "إختر ترتيب الإختيارات",
    visible: "مرئي؟",
    isRequired: "مطلوب؟",
    isAllRowRequired: "المطالبة بالأجوبة لكل الصفوف",
    requiredErrorText: "نص خطأ إلزامي السؤال",
    startWithNewLine: "إظهار السؤال في صف جديد",
    rows: "عدد الصفوف",
    cols: "عدد الأعمدة",
    placeholder: "نص حامل خانة الإدخال",
    showPreview: "عرض منطقة المعاينة",
    storeDataAsText: "تخزين محتويات ملف JSON كنص",
    maxSize: "أقصى حجم للملف بالبايت",
    imageHeight: "طول الصورة",
    imageWidth: "عرض الصورة",
    rowCount: "عدد الصفوف",
    columnLayout: "تخطيط الأعمدة",
    addRowLocation: "موقع زر إضافة صف",
    addRowText: "نص زر إضافة صف",
    removeRowText: "نص زر حذف صف",
    rateMin: "أصغر معدل",
    rateMax: "أكبر معدل",
    rateStep: "خطوات المعدل",
    minRateDescription: "وصف أصغر معدل",
    maxRateDescription: "وصف أكبر معدل",
    inputType: "نوع المدخل",
    optionsCaption: "خيارات الشرح",
    showOptionsCaption: "Show options caption",
    defaultValue: "القيمة الإفتراضية",
    cellsDefaultRow: "Default cells texts",
    surveyEditorTitle: "Edit survey settings",
    qEditorTitle: "Edit: {0}",
    maxLength: "أقصى طول",
    buildExpression: "Build",
    editExpression: "التعديل",
    and: "أو",
    or: "و",
    remove: "إزالة",
    addCondition: "أضف الشرط",
    if: "إذا قيمة",
    then: "من ثم",
    setToName: "إلى",
    fromName: "from",
    ruleIsNotSet: "Rule is incorrect",
    //survey
    showTitle: "إظهار/إخفاء العنوان",
    expandCollapseTitle: "Expand/collapse title",
    locale: "اللغة الإفتراضية",
    simulator: "Choose device",
    landscapeOrientation: "Landscape",
    portraitOrientation: "Portrait",
    mode: "النمط (التعديل، القرائة فقط)",
    clearInvisibleValues: "إمسح القيم الغير مرئية",
    cookieName: "أدخل إسم ملف تعريف الإرتباط (لتعطيل المشاركة بالإستبيان أكثر من مرة)",
    sendResultOnPageNext: "إرسال نتائج الإستبيان على الصفحة التالية",
    storeOthersAsComment: "تخزين قيمة 'أخرى' في حقل منفصل",
    showPageTitles: "عرض عنوان الصفحات",
    showPageNumbers: "عرض أرقام الصفحات",
    pagePrevText: "نص زر الإنتقال للصفحة السابقة",
    pageNextText: "نص زر الإنتقال للصفحة التالية",
    completeText: "نص زر إنهاء الإستبيان",
    previewText: "نص زر المعاينة",
    editText: "نص زر التعديل",
    startSurveyText: "نص زر بدء المشاركة بالإستبيان",
    showNavigationButtons: "إظهار أزرار الإنتقال (التنقل الإفتراضي)",
    showPrevButton: "إظهار زر التنقل السابق (السماح للمستخدم من العودة للصفحة السابقة في الإستبيان)",
    firstPageIsStarted: "الصفحة الأولى في الإستبيان هي صفحة البدء",
    showCompletedPage: "إظهار الصفحة المكتملة في النهاية (صفحة ويب مكتملة)",
    goNextPageAutomatic: "عند الإجابة على جميع الأسئلة، إنتقل إلى الصفحة التالية تلقائياً",
    showProgressBar: "إظهار شريط التقدم",
    questionTitleLocation: "موقع عنوان السؤال",
    requiredText: "رمز السؤال مطلوب",
    questionStartIndex: "فهرس بداية الأسئلة (1،2 أو 'أ' ، 'ب')",
    showQuestionNumbers: "إظهار أرقام الأسئلة",
    questionTitleTemplate: "Question title template, default is: '{no}. {require} {title}'",
    questionErrorLocation: "موقع خطأ في السؤال",
    focusFirstQuestionAutomatic: "ركز المؤشر على السؤال الأول عند تغير الصفحة",
    questionsOrder: "ترتيب العناصر على الصفحة",
    maxTimeToFinish: "أقصى وقت لإنهاء الإستبيان",
    maxTimeToFinishPage: "أقصى وقت لإنهاء الصفحة في الإستبيان",
    showTimerPanel: "إظهار لوحة المؤقت",
    showTimerPanelMode: "إظهار نمط لوحة المؤقت",
    renderMode: "نمط العرض",
    allowAddPanel: "السماح بإضافة لوحة",
    allowRemovePanel: "السماح بإزالة لوحة",
    panelAddText: "نص إضافة لوحة",
    panelRemoveText: "نص إزالة لوحة",
    isSinglePage: "Show all elements on one page",
    html: "صفحة ويب HTML",
    expression: "عملية حسابية",
    minValue: "أقل قيمة",
    maxValue: "أكبر قيمة",
    minLength: "Minimum length",
    allowDigits: "Allow digits",
    minCount: "Minimum count",
    maxCount: "Maximum count",
    regex: "Regular expression",
    totalText: "Total text",
    totalType: "Total type",
    totalExpression: "Total expression",
    totalDisplayStyle: "Total display style",
    totalCurrency: "Total currency",
    totalFormat: "Total format",
    // Header  adorner
    logoPosition: "Logo position",
    addLogo: "Add logo...",
    changeLogo: "Change logo...",
    logoPositions: {
      none: "حذف الشعار",
      left: "يسار",
      right: "يمين",
      top: "في الأعلى",
      bottom: "في الأسفل",
    },
    tabs: {
      general: "عام",
      fileOptions: "الخيارات",
      html: "Html Editor",
      columns: "الأعمدة",
      rows: "الصفوف",
      choices: "الخيارات",
      items: "العناصر",
      visibleIf: "مرئي عندما",
      enableIf: "مفعل عندما",
      requiredIf: "مطلوب عندما",
      rateValues: "قيم التقييم",
      choicesByUrl: "خيارات من الإنترنت",
      matrixChoices: "Default Choices",
      multipleTextItems: "Text Inputs",
      numbering: "الترقيم",
      validators: "المدققات",
      navigation: "التنقل",
      question: "السؤال",
      pages: "الصفحات",
      completedHtml: "صفحة الويب المكتملة",
      completedHtmlOnCondition: "صفحة ويب مكتملة بشرط",
      loadingHtml: "Loading Html",
      timer: "مؤقت/إختبار قصير",
      calculatedValues: "Calculated Values",
      triggers: "Triggers",
      templateTitle: "عنوان القالب",
      totals: "Totals",
      logic: "المنطق",
      layout: "التنسيق",
      data: "البيانات",
      validation: "التحقق",
      cells: "الخلايا",
      showOnCompleted: "عند الإنتهاء من الإستبيان",
      logo: "الشعار في عنوان الإستبيان",
      slider: "Slider",
      others: "غير ذلك",
    },
    editProperty: "Edit property '{0}'",
    items: "Items",
    enterNewValue: "Please, enter the value.",
    noquestions: "There is no any question in the survey.",
    createtrigger: "Please create a trigger",
    titleKeyboardAdornerTip: "Press enter button to edit",
    keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item",
    triggerOn: "On ",
    triggerMakePagesVisible: "Make pages visible:",
    triggerMakeQuestionsVisible: "Make elements visible:",
    triggerCompleteText: "Complete the survey if succeed.",
    triggerNotSet: "The trigger is not set",
    triggerRunIf: "Run if",
    triggerSetToName: "Change value of: ",
    triggerFromName: "Copy value from: ",
    triggerRunExpression: "Run this Expression:",
    triggerSetValue: "to: ",
    triggerGotoName: "Go to the question:",
    triggerIsVariable: "Do not put the variable into the survey result.",
    triggerRunExpressionEmpty: "Please enter a valid expression",
    noFile: "No file choosen",
  },
  //Property values
  pv: {
    auto: "تلقائي",
    static: "ثابتة",
    responsive: "متجاوب",
    contain: "إحتواء",
    cover: "تغطية",
    fill: "ملئ",
    onBlur: "عند الطمس",
    onTyping: "عند الكتابة",
    video: "فيديو",
    image: "صور",
    true: "صحيح",
    false: "خطأ",
    inherit: "يَرث",
    show: "إظهار",
    hide: "إخفاء",
    initial: "مبدئي",
    random: "عشوائي",
    collapsed: "مقلص",
    expanded: "موسع",
    none: "بلا",
    asc: "تصاعدي",
    desc: "تنازلي",
    indeterminate: "غير محدد",
    decimal: "عدد عشري",
    currency: "العملة",
    percent: "نسبة مئوية",
    firstExpanded: "توسيع أول لوح",
    off: "إيقاف",
    onPanel: "على اللوحة",
    onSurvey: "على الإستبيان",
    list: "قائمة",
    progressTop: "التقدم بالأعلى",
    progressBottom: "التقدم بالأسف",
    progressTopBottom: "التقدم بالأعلى والأسفل معاً",
    horizontal: "عرضي",
    vertical: "عمودي",
    default: "الإفتراضي",
    top: "الأعلى",
    bottom: "الأسفل",
    topBottom: "الاعلى والأسفل",
    both: "الكل",
    left: "يسار",
    right: "يمين",
    color: "لون",
    date: "تاريخ",
    datetime: "تاريخ ووقت",
    "datetime-local": "تاريخ ووقت محلي",
    email: "بريد إلكتروني",
    month: "شهر",
    number: "أرقام",
    password: "كلمة سر",
    range: "نطاق",
    tel: "رقم هاتف",
    text: "نص",
    time: "وقت",
    url: "رابط إلكتروني URL",
    week: "إسبوع",
    hidden: "مخفي",
    on: "تشغيل",
    onPage: "على الصفحة",
    edit: "التعديل",
    display: "العرض",
    onComplete: "عند الإنتهاء",
    onHidden: "عند الإخفال",
    onHiddenContainer: "عند إخفاء الحاوية",
    all: "الكل",
    page: "الصفحة",
    survey: "الإستبيان",
    onNextPage: "عند الإنتقال للصفحة التالية",
    onValueChanging: "عند تغيير القيمة",
    onValueChanged: "إذا تغيرت القيمة",
    singlePage: "صفحة واحدة",
    standard: "أساسي",
    questionPerPage: "سؤال لكل صفحة",
    noPreview: "بلا عرض",
    showAllQuestions: "المعاينة مع جميع الأسئلة",
    showAnsweredQuestions: "المعاينة مع الأسئلة المجٌابة",
    pages: "الصفحات",
    questions: "الأسئلة",
    requiredQuestions: "الأسئلة المطلوبة",
    correctQuestions: "الإجابات الصحيحة",
    buttons: "الأزرار",
    underInput: "أسفل خانة الإدخال",
    underTitle: "أعلى العنوان",
  },
  //Operators
  op: {
    empty: "فارغة",
    notempty: "ليست فارغة",
    equal: "تساوي",
    notequal: "لا تساوي",
    contains: "تحتوي",
    notcontains: "لا تحتوي",
    anyof: "أي من",
    allof: "كلاً من",
    greater: "أكبر",
    less: "أقل",
    greaterorequal: "أكبر أو يساوي",
    lessorequal: "أقل أو يساوي",
    and: "و",
    or: "أو",
  },
  //Embed window
  ew: {
    angular: "Use Angular version",
    jquery: "Use jQuery version",
    knockout: "Use Knockout version",
    react: "Use React version",
    vue: "Use Vue version",
    bootstrap: "For bootstrap framework",
    modern: "Modern theme",
    default: "Default theme",
    orange: "Orange theme",
    darkblue: "Darkblue theme",
    darkrose: "Darkrose theme",
    stone: "Stone theme",
    winter: "Winter theme",
    winterstone: "Winter-Stone theme",
    showOnPage: "Show survey on a page",
    showInWindow: "Show survey in a window",
    loadFromServer: "Load Survey JSON from server",
    titleScript: "Scripts and styles",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript",
  },
  //Preview (Survey)
  ts: {
    selectPage: "Select the page to test it:",
    showInvisibleElements: "إظهار العناصر المخفية",
  },
  validators: {
    answercountvalidator: "answer count",
    emailvalidator: "بريد إلكتروني",
    expressionvalidator: "عملية حسابية",
    numericvalidator: "رقمية",
    regexvalidator: "تعبير رياضي",
    textvalidator: "النص",
  },
  triggers: {
    completetrigger: "إنهاء الإستبيان",
    setvaluetrigger: "تحديد قيمة",
    copyvaluetrigger: "نسخ قيمة",
    skiptrigger: "الإنتقال إلى سؤال",
    runexpressiontrigger: "تشغيل العملية الحسابية",
    visibletrigger: "تغيير الرؤية (مهمل)",
  },
  pehelp: {
    //expression:
  },
  //Properties
  p: {
    name: "الإسم",
    title: {
      name: "title",
      title: "Leave it empty, if it is the same as 'Name'",
    },
    navigationButtonsVisibility: "رؤية أزرار التنقل",
    questionsOrder: "questionsOrder",
    maxTimeToFinish: "maxTimeToFinish",
    visible: "مرئي",
    visibleIf: "مرئي عندما",
    questionTitleLocation: "questionTitleLocation",
    description: "الوصف",
    state: "الحالة",
    isRequired: "مطلوب؟",
    requiredIf: "مطلوب عندما",
    indent: "المسافة البادئة",
    requiredErrorText: "requiredErrorText",
    startWithNewLine: "startWithNewLine",
    innerIndent: "المسافة البادئة الداخلية",
    page: "الصفحة",
    width: "العرض",
    commentText: "نص التعليق",
    valueName: "valueName",
    enableIf: "فعال عندما",
    defaultValue: "القيمة الإفتراضية",
    correctAnswer: "الإجابة الصحيحة",
    readOnly: "للقرائة فقط",
    validators: "المدققات",
    titleLocation: "موقع عنوان السؤال",
    showCommentArea: "هل هناك تعليق؟",
    showOtherItem: "hasOther",
    choices: "الإختيارات",
    choicesOrder: "choicesOrder",
    choicesByUrl: "خيار عن طريق رابط إلكتروني URL",
    otherText: "otherText",
    otherErrorText: "otherErrorText",
    storeOthersAsComment: "storeOthersAsComment",
    label: "المسمى",
    showTitle: "showTitle",
    valueTrue: "قيمة صحيح",
    valueFalse: "قيمة خطأ",
    cols: "الأعمدة",
    rows: "الصفوف",
    optionsCaption: "optionsCaption",
    expression: "expression",
    format: "الصيغة",
    displayStyle: "أسلوب العرض",
    currency: "currency",
    useGrouping: "إستخدام التجميع",
    showPreview: "showPreview",
    allowMultiple: "السماح بالمتعدد",
    imageHeight: "imageHeight",
    imageWidth: "imageWidth",
    storeDataAsText: "storeDataAsText",
    maxSize: "maxSize",
    html: "صفحة ويب HTML",
    columns: "الأعمدة",
    cells: "الخليات",
    isAllRowRequired: "isAllRowRequired",
    horizontalScroll: "تمرير أٌفقي بالمؤشر",
    cellType: "نوع الخلية",
    columnsLayout: "columnsLayout",
    columnColCount: "عدد تقسيم العمود",
    columnMinWidth: "أقل عرض للعمود",
    rowCount: "عدد الصفوف",
    minRowCount: "أقل عدد للصفوف",
    maxRowCount: "أكبر عدد للصفوف",
    keyName: "إسم المفتاح",
    keyDuplicationError: "خطأ تكرار المفتاح",
    confirmDelete: "رسالة تأكيد الحذف",
    confirmDeleteText: "نص رسالة تأكيد الحذف",
    addRowLocation: "addRowLocation",
    addRowText: "addRowText",
    removeRowText: "removeRowText",
    items: "items",
    itemSize: "itemSize",
    colCount: "colCount",
    templateTitle: "عنوان القالب",
    templateDescription: "وصف القالب",
    allowAddPanel: "allowAddPanel",
    allowRemovePanel: "allowRemovePanel",
    panelCount: "عدد اللوحات",
    minPanelCount: "أقل عدد للوحات",
    maxPanelCount: "أعلى عدد للوحات",
    panelsState: "حالة الوحة",
    panelAddText: "نص إضافة لوحة",
    panelRemoveText: "نص حذف لوحة",
    panelPrevText: "نص اللوحة السابقة",
    panelNextText: "نص اللوحة التالية",
    showQuestionNumbers: "showQuestionNumbers",
    showRangeInProgress: "عرض نطاق القيد التقدم",
    renderMode: "نمط العرض",
    templateTitleLocation: "موقع عنوان القالب",
    rateValues: "قييم التقييم",
    rateMin: "rateMin",
    rateMax: "rateMax",
    rateStep: "rateStep",
    minRateDescription: "minRateDescription",
    maxRateDescription: "maxRateDescription",
    inputType: "inputType",
    size: "الحجم",
    locale: "اللغة",
    focusFirstQuestionAutomatic: "focusFirstQuestionAutomatic",
    completedBeforeHtml: "الإنتهاء قبل HTML",
    loadingHtml: "تحميل HTML",
    triggers: "المحفزات",
    cookieName: "cookieName",
    sendResultOnPageNext: "sendResultOnPageNext",
    showNavigationButtons: "showNavigationButtons",
    showPrevButton: "showPrevButton",
    showPageTitles: "showPageTitles",
    showCompletedPage: "showCompletedPage",
    showPageNumbers: "showPageNumbers",
    questionErrorLocation: "questionErrorLocation",
    showProgressBar: "showProgressBar",
    mode: "mode",
    goNextPageAutomatic: "goNextPageAutomatic",
    checkErrorsMode: "نمط التحقق من الأخطاء",
    clearInvisibleValues: "clearInvisibleValues",
    startSurveyText: "startSurveyText",
    pagePrevText: "pagePrevText",
    pageNextText: "pageNextText",
    completeText: "completeText",
    requiredText: "requiredText",
    questionStartIndex: "questionStartIndex",
    questionTitleTemplate: "questionTitleTemplate",
    firstPageIsStarted: "firstPageIsStarted",
    isSinglePage: "isSinglePage",
    maxTimeToFinishPage: "maxTimeToFinishPage",
    showTimerPanel: "showTimerPanel",
    showTimerPanelMode: "showTimerPanelMode",
    defaultPanelValue: "القيمة الإفتراضية للوحة",
    defaultRowValue: "قيمة الصف الإفتراضية",
    showNoneItem: "hasNone",
    noneText: "noneText",
    text: "نص",
    multiSelect: "متعدد الإختيار",
    showLabel: "عرض الملصق",
    logo: "الشعار",
    logoWidth: "عٌرض الشعار",
    logoHeight: "طول الشعار",
    logoFit: "تناسب الشعار",
    focusOnFirstError: "تركيز المؤشر على أول خطأ",
    pages: "الصفحات",
    calculatedValues: "القيم المحسوبة",
    includeIntoResult: "الإضافة إلى النتائج",
    navigateToUrl: "الإنتقال إلى رابط URL",
    completedHtml: "صفحة الويب المكتملة",
    completedHtmlOnCondition: "صفحة ويب مكتملة بشرط",
    navigateToUrlOnCondition: "الإنتقال إلى رابط إلكتروني بشرط",
    questionDescriptionLocation: "موقع وصف السؤال",
    progressBarType: "نوع شريط التقدم",
    maxTextLength: "أقصى طٌول للنص",
    maxOthersLength: "أقصى طول لخيار 'أخرى'",
    textUpdateMode: "نمط تحديث النص",
    autoGrowComment: "نمو تلقائي للسؤال من نوع تعليق",
    questionTitlePattern: "تنسيق عنوان السؤال",
    questionsOnPageMode: "الأسئلة في الصفحات",
    showPreviewBeforeComplete: "المعاينة قبل الإنتهاء من الإستبيان",
    widthMode: "نمط عٌرض الشاشة",
    showNumber: "عرض الرقم",
    navigationTitle: "navigationTitle",
    navigationDescription: "navigationDescription",
    useDisplayValuesInDynamicTexts: "إستخدم عرض القيم في العنوان",
    setDefaultValue: "تثبيت قيمة إفتراضية",
    setCorrectValue: "تثبيت إجابة صحيحة",
    minWidth: "أقل عرض",
    maxWidth: "أعلى عرض",
    descriptionLocation: "موقع وصف السؤال",
    hideNumber: "إخفاء رقم السؤال",
    defaultValueExpression: "العملية الحسابية الإفتراضية",
    bindings: "الإرتباطات",
    value: "القيمة",
    columnsVisibleIf: "أظهر الأعمدة إذا",
    rowsVisibleIf: "أظهر الصفوف إذا",
    showHeader: "عرض رأس المصفوفة",
    detailPanelMode: "نمط تفاصيل اللوحة",
    rowTitleWidth: "rowTitleWidth",
    allowAddRows: "السماح إضافة صفوف",
    allowRemoveRows: "السماح لإزالة صفوف",
    defaultValueFromLastRow: "القيمة الإفتراضية تكون من الصف الأخير",
    hideColumnsIfEmpty: "إخفاء في حالة كان العمود فارغ",
    emptyRowsText: "emptyRowsText",
    detailPanelShowOnAdding: "detailPanelShowOnAdding",
    allowRowsDragAndDrop: "السماح للسحب والإدراج للصفوف",
    rowsOrder: "ترتيب الصفوف",
    hideIfRowsEmpty: "إخفاء إذا كان الصف فارغ",
    maximumFractionDigits: "الحد الأقصى للكسور",
    minimumFractionDigits: "الحد الأدنى للكسور",
    choicesFromQuestion: "الإختيارات من الأسئلة",
    choicesFromQuestionMode: "choicesFromQuestionMode",
    hideIfChoicesEmpty: "إخفاء عندما تكون الخيارات فارغة",
    choicesVisibleIf: "الإختيارات مرئية عندما",
    choicesEnableIf: "الإختيارات مفعلة عندما",
    otherPlaceHolder: "حامل نص لخيار الأخرى",
    maxSelectedChoices: "أقصى عدد للإختيار",
    showClearButton: "showClearButton",
    contentMode: "نمط عرض المحتوى",
    imageFit: "إحتواء الصورة",
    autocomplete: "الإكمال التلقائي",
    min: "أقل",
    max: "أكبر",
    minValueExpression: "minValueExpression",
    maxValueExpression: "maxValueExpression",
    minErrorText: "minErrorText",
    maxErrorText: "maxErrorText",
    step: "step",
    dataList: "قائمة البيانات",
    autoGrow: "تمدد تلقائي",
    multiLine: "multiLine",
    allowImagesPreview: "السماح بعرض الصور",
    acceptedTypes: "الأنواع المسموح بها",
    waitForUpload: "الإنتظار للرفع",
    needConfirmRemoveFile: "سؤال تأكيد لحذف الملف",
    labelTrue: "ملصق صحيح",
    labelFalse: "ملصق خطأ",
    height: "height",
    allowClear: "allowClear",
    penColor: "لون القلم",
    backgroundColor: "لون الخلفية",
    dataFormat: "صيغة البيانات",
    defaultValueFromLastPanel: "القيمة الإفتراضية من أخر لوحة",
    panelRemoveButtonLocation: "موقع زر حذف اللوحة",
    showCaption: "showCaption",
    iconName: "iconName",
    iconSize: "iconSize"
  }
};

//Uncomment this line on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
editorLocalization.locales["ar"] = arStrings;